const FacultyList = [
    {
      image: "/Abhay-Sardesai-min.jpg",
      title: "Abhay Sardesai",
      description: "Former Editor of Art India Magazine",
      link: "/teams/abhay-sardesai"
    },
    {
      image: "/Dadiba-Pundole-min.jpg",
      title: "Dadiba Pundole",
      description: "Owns one of Mumbai’s oldest commercial art spaces – Pundole Gallery",
      link: "/teams/dadiba-pundole"
    },
    {
      image: "/jitish-bio-scaled.jpg",
      title: "Jitish Kallat",
      description: "Leading Contemporary Artist and Curator",
      link: "/teams/jitish-kallat"
    },
    {
      image: "/Kamayani-Sharma-bio.jpg",
      title: "Kamayani Sharma",
      description: "Independent Writer, Researcher, Translator and Podcaster",
      link: "/teams/kamayani-sharma"
    },
    {
      image: "/Meera-M_-photo-copyright-Parthiv-Shah-1.jpg",
      title: "Meera Menezes",
      description: "Acclaimed Art Writer and Independent Curator",
      link: "/teams/meera-menezes"
    },
    {
      image: "/Sandhya-Bordewekar-bio-scaled.jpg",
      title: "Sandhya Bordewekar",
      description: "Art Educator, Writer and Curator",
      link: "/teams/sandhya-bordewekar"
    },
    {
      image: "/Tasneem-Zakaria-Mehta-2.jpg",
      title: "Tasneem Zakaria Mehta",
      description: "Managing Trustee and Honorary Director, Dr. Bhau Daji Lad Museum, Mumbai",
      link: "/teams/tasneem-zakaria-mehta"
    },
    {
      image: "/Yashodhara-Dalmia-min.jpg",
      title: "Yashodhara Dalmia",
      description: "An art historian and independent curator based in New Delhi",
      link: "/teams/yashodhara-dalmia"
    },
    {
      image: "/Zehra-Jumabhoy-min.jpg",
      title: "Zehra Jumabhoy",
      description: "An art historian, curator and writer based in the U.K.",
      link: "/teams/zehra-jumabhoy"
    },
  ];
  
  export default FacultyList;